import {I9DocumentTypesEnum, useUploadDocumentContext,} from '@swipejobs/i9-document-validations-react';
import {ISection2DocumentUploadStore} from '@stores/onboarding-review/section2-document-upload-store';
import {get, reduce} from 'lodash';
import {DocumentUploadResponse} from '@models/onboarding-review/section2-document-upload';
import {IPersonPidEncryptionService} from '@services/onboarding-review/person-pid-encryption-service';
import {EncryptedDto} from '@dtos/encrypted-dto';
import {OnConfirmType} from '@models/onConfirm-type';

const useSaveDocumentUpload = (
    store: ISection2DocumentUploadStore,
    onConfirm: OnConfirmType
) => {
    const {getUploadDocumentPayload, savedDocuments} = useUploadDocumentContext();

    const handleUploadDocumentNumbers = async (
        documentUploadResponse: DocumentUploadResponse[],
        pidService: IPersonPidEncryptionService
    ) => {
        if (!documentUploadResponse?.length) {
            return;
        }

        // prepare doc types and ids
        const documentTypesAndIds = documentUploadResponse.reduce(
            (prev, curr) => ({...prev, ...curr.currentDocumentEntries}),
            {} as Record<keyof typeof I9DocumentTypesEnum, string>,
        );

        // prepare doc ids and numbers
        const documentIdsToDocumentNums = savedDocuments.reduce((prev, curr) => {
            const uploadedDocumentId: I9DocumentTypesEnum = get(
                documentTypesAndIds,
                curr.documentType ?? '',
            );
            if (!uploadedDocumentId) return prev;
            return {
                ...prev,
                [uploadedDocumentId]: curr.documentNumber,
            };
        }, {});

        // encrypts doc number
        const cipheredData: Record<string, EncryptedDto> = reduce(
            documentIdsToDocumentNums,
            (prev, curr, key) => ({...prev, [key]: pidService.encryptDto(curr)}),
            {},
        );

        // upload doc numbers
        await store.updateDocumentNumbersAsync({
            documentNumbers: cipheredData
        });
    }

    const handleUploadSavedDocuments = async () => {
        // 1. upload doc api
        // 2. extract uploaded doc response ids
        // 3. prepare doc ids, encrypts numbers
        // 4. upload doc numbers
        const documents = getUploadDocumentPayload();
        onConfirm?.(documents, handleUploadDocumentNumbers);
    };

    return {
        handleUploadSavedDocuments,
        isLoading: store.isLoading
    };
};

export default useSaveDocumentUpload;



// WEBPACK FOOTER //
// ./src/hooks/useSaveDocumentUpload.tsx